<template>
  <div class="rec">
    <label>Reason</label>
    <input class="reason" type="text" v-model="recommendation.reason">
    <Condition :condition.sync="recommendation.condition" :first="true" />
    <label>Products</label>
    <div class="product" v-for="(product,i) in recommendation.products" :key="i">
    <input class="reason" type="text" v-model="recommendation.products[i]">
    <button @click="recommendation.products.splice(i,1)">
      X
    </button>
    </div>
    <button @click="recommendation.products.push('')">
      + Add
    </button>
    <br>
    <br>
    <button @click="$emit('delete')">
      X Delete Recommendation
    </button>
  </div>
</template>

<script>
import Condition from './Condition'

export default {
    name: 'Recommendation',
    components: {
      Condition
    },
    props: {
      recommendation: {
        type: Object,
        default(){
          return {}
        }
      }
    }
}
</script>

<style>
.reason{
  width: 100%;
}

.rec{
  text-align: left;
  margin: 32px;
  padding: 12px;
  border: 1px solid #707070;
}

.product{
  max-width: 380px;
  display: flex;
}
</style>